import Router from 'vue-router'

import staticRouters from './static-routers'
import businessRouters from './business-routers'

/* Router Modules */
import lnbasesettingRouter from './modules/lnbasesetting'
import menudishesRouter from './modules/lnmenudishes'
import orderingRouter from './modules/lnordering'
/* 营销规则 */
import marketingRouter from './modules/lnmarketing'
/* 通知中心 */
// import noticeRouter from './modules/lnnotice';
import noticeV2Router from './modules/lnnoticeV2'

/* 用户中心 */
import lnpersonalcenterRouter from './modules/lnpersonalcenter'
/* 账户中心 */
import accountCenterRouter from './modules/accountCenter'
/* 健康中心 */
import lnhealthcenterRouter from './modules/lnhealthcenter'
/* 采购中心 */
// import lncaigoucenterRouter from './modules/lncaigoucenter'
/* 采购库存 */
import lnkucuncenterRouter from './modules/lnkucuncenter'
/* 采购中心 */
import lnbaobiaocenterRouter from './modules/lnbaobiaocenter'
/* 采购中心 */
import lnattendanceRouter from './modules/Inattendance'
/* 商户初始化 */
// import lnInitializedRouter from './modules/lnInitialized'
/* 宿管 */
import lnDormitoryRouter from './modules/InDormitory'
/* 图片审核 */
// import lnpictureexamineRouter from './modules/lnpictureexamine'
/* 商户中心 */
// import lnBusinessReviewRouter from './modules/lnBusinessReview'
/* 数据大屏 */
import lndatahunterRouter from './modules/lndatahunter'
// 设备管理
import deviceManagerRouter from './modules/deviceManager'
import mobileRouter from './modules/InMobile'
import canteenBackcourtRouter from './modules/canteenBackcourt'
// 商超
import lnsuperRouter from './modules/superstore'
// 门禁系统
import doorControlRouter from './modules/doorControl'
// 审批
import ApprovalRouter from './modules/approval'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
	lnbasesettingRouter,
	mobileRouter,
	deviceManagerRouter,
	menudishesRouter,
	orderingRouter,
	marketingRouter,
	// noticeRouter,
	noticeV2Router,
	lnpersonalcenterRouter,
	accountCenterRouter,
	lnhealthcenterRouter,
	// lncaigoucenterRouter,
	lnkucuncenterRouter,
	lnbaobiaocenterRouter,
	lnDormitoryRouter,
	lnsuperRouter,
	lnattendanceRouter,
	doorControlRouter,
	ApprovalRouter,
	// 商户初始化
	businessRouters,
	canteenBackcourtRouter,
	// 商家中心
	// lnBusinessReviewRouter,
	lndatahunterRouter
	// lnpictureexamineRouter,
	// lndatahunterRouter,
]

const createRouter = () =>
	new Router({
		// mode: 'history', // require service support
		scrollBehavior: () => ({
			y: 0
		}),
		routes: staticRouters
	})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router
